// Accordion
$(function() {
	// (Optional) Active an item if it has the class "is-active"	
	$(".accordion > .accordion-item.is-active").children(".accordion-item .metafield-rich_text_field").slideDown();
	
	$(".accordion > .accordion-item").click(function() {
		// Cancel the siblings
		$(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-item .metafield-rich_text_field").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-item .metafield-rich_text_field").slideToggle("ease-out");
	});
});